module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/bath-91f04f5d2877de33cfb2b44d12adf641.svg";